import { ForestProductGroupEntity } from './ForestProductGroupEntity';

export class ForestProductEntity {
  id: number;
  name_En: string;
  name_Fr: string;
  description_En: string;
  description_Fr: string;
  forestProductGroup: ForestProductGroupEntity;
  notes: string;

  constructor(entity?: ForestProductEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
      this.name_En = '';
      this.name_Fr = '';
      this.description_En = '';
      this.description_Fr = '';
      this.notes = '';
    }
  }
}
